import { useMutation } from '@tanstack/react-query';
import { OrganizationDto, UpdateOrganizationCancellationMessagesDto } from 'models/organization/dto/organization.dto';
import { useApiClient } from '../../../apiClient';
import { useSelectedOrganization } from './useSelectedOrganization';

// Mirrors useUpdateOrganizationRefundDeadline. Sends both messages in one
// request; the API merges per-field (undefined leaves alone, null clears).
// The card always sends both fields together, but the hook stays generic for
// future callers that may want to patch just one.
export const useUpdateOrganizationCancellationMessages = (
    organizationId: string,
    onSuccess: () => void,
) => {
    const apiClient = useApiClient();
    const { selectedOrganization, setSelectedOrganization } = useSelectedOrganization();

    return useMutation({
        mutationKey: ['updateOrganizationCancellationMessages', organizationId],
        mutationFn: (body: UpdateOrganizationCancellationMessagesDto) =>
            apiClient.fetchApi<OrganizationDto, UpdateOrganizationCancellationMessagesDto>({
                method: 'POST',
                endpoint: `organizations/${organizationId}/cancellation-messages`,
                body,
            }),
        onSuccess: (data) => {
            onSuccess();
            if (data.id === selectedOrganization?.id) {
                setSelectedOrganization(data);
            }
        },
    });
};
